import classes from './WhyRatezip.module.css'

import bbbLogo from '../../../assets/images/bbb_logo.png'
import norton from '../../../assets/images/norton.png'
import shopperApproved from '../../../assets/images/shopper_approved.png'
import compareLoans from '../../../assets/images/compare_loan_img.webp'

function WhyRatezip() {
    return(
        <>
            <div className={classes.container}>
                <h2>Why RateZip?</h2>
                <ul>
                    <li>Top rates from leading banks</li>
                    <li>100% FDIC insured</li>
                    <li>No minimum deposit options</li>
                </ul>
                <img loading="lazy" src={bbbLogo} alt="bbb" />
                <img loading="lazy" src={norton} alt="norton" />
                <img loading="lazy" src={shopperApproved} alt="shopper approved" />
            </div>
            <div className={classes.container}>
                <h2>How It Works</h2>
                <p>Our partner, Bankrate, surveys nearly 5,000 banks and credit unions in all 50 states to provide one of the most comprehensive comparisons of rates. All of the savings accounts below are insured by the FDIC at banks or the NCUA at credit unions. When selecting the best savings account for you, look for the highest yield while also considering introductory rates, minimum balances and accessibility.</p>
            </div>
            <div className={classes.container}>
                <h2>Top Brands</h2>
                <img src={compareLoans} alt="compare loans" />
            </div>
        </>
    )
}

export default WhyRatezip